/**
 * NDG Invitation Form — view.js
 *
 * Store Interactivity API pour le formulaire d'invitation ("invité par" +
 * 2 invités nommés, le second optionnel).
 */

import { store, getContext } from '@wordpress/interactivity';
import { getRecaptchaToken, preloadRecaptcha } from '../../js/utils/recaptcha.js';

const STORE_NS = 'ndg/invitation-form';

function escapeHtml( str ) {
	const div = document.createElement( 'div' );
	div.textContent = str;
	return div.innerHTML;
}

store( STORE_NS, {

	actions: {

		preloadRecaptcha() {
			preloadRecaptcha( getContext().recaptchaSiteKey );
		},

		setField( event ) {
			const field = event.target.dataset.field;
			if ( field ) {
				getContext()[ field ] = event.target.value;
			}
		},

		// Event (ville) choisi : repeuple le select "Horaire" avec les
		// séances de cet event (pas de <template> dans <select> : le HTML
		// n'autorise que option/optgroup comme enfants, donc DOM direct).
		selectEvent( event ) {
			const context   = getContext();
			const eventId   = event.target.value;
			context.eventId = eventId;
			context.sessionId = '';

			const form          = event.target.closest( 'form' );
			const sessionSelect = form && form.querySelector( '[data-field="sessionId"]' );
			if ( ! sessionSelect ) return;

			const sessions = context.eventSessions[ eventId ] || [];

			sessionSelect.innerHTML =
				`<option value="">${ escapeHtml( context.sessionPlaceholder ) }</option>` +
				sessions
					.map( ( s ) => `<option value="${ escapeHtml( s.value ) }">${ escapeHtml( s.label ) }</option>` )
					.join( '' );

			sessionSelect.disabled = sessions.length === 0;
		},

		*submit( event ) {
			event.preventDefault();

			const context = getContext();

			if ( context.isSubmitting ) return;

			context.isSubmitting = true;
			context.isSuccess    = false;
			context.isError      = false;

			try {
				const token = yield getRecaptchaToken( context.recaptchaSiteKey, context.recaptchaAction );

				const response = yield fetch( context.restUrl, {
					method:  'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-WP-Nonce':   context.nonce,
					},
					body: JSON.stringify( {
						inviter:           context.inviter,
						guest1_lastname:   context.guest1Lastname,
						guest1_firstname:  context.guest1Firstname,
						guest1_email:      context.guest1Email,
						guest2_lastname:   context.guest2Lastname,
						guest2_firstname:  context.guest2Firstname,
						guest2_email:      context.guest2Email,
						event_id:          context.eventId,
						event_session:     context.sessionId,
						comment:           context.comment,
						website:           context.website,
						recaptcha_token:   token,
					} ),
				} );

				const data = yield response.json();

				if ( response.ok && data.ok ) {
					context.isSuccess        = true;
					context.inviter          = '';
					context.guest1Lastname   = '';
					context.guest1Firstname  = '';
					context.guest1Email      = '';
					context.guest2Lastname   = '';
					context.guest2Firstname  = '';
					context.guest2Email      = '';
					context.eventId          = '';
					context.sessionId        = '';
					context.comment          = '';

					const form          = event.target.closest( 'form' );
					const sessionSelect = form && form.querySelector( '[data-field="sessionId"]' );
					if ( sessionSelect ) {
						sessionSelect.innerHTML = `<option value="">${ escapeHtml( context.sessionPlaceholder ) }</option>`;
						sessionSelect.disabled  = true;
					}
				} else {
					context.isError = true;
				}
			} catch {
				context.isError = true;
			} finally {
				context.isSubmitting = false;
			}
		},
	},
} );
